import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faPenToSquare,faMultiply,faSave, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import ButtonOverride from "../../../../../components/buttonoverride";
import styles from '../../../../../styles/fileupload.module.css';
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";

const smallAddButtonStyle = {
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    minWidth: "32px",
    minHeight: "32px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

const InspectionsQuickAdd = ({ActionTypes = [],InspectionStatuses = [],InspectionTypes = [],prepend}) => {
    const inspectionReportRef = useRef(null);
    const [inspectionReport,setInspectionReport] = useState(null);
        
    const waiverRef = useRef(null);
    const [waiverUpload,setWaiverUpload] = useState(null);
        
    const _handleInspectionReportFileClick = () => {
        if(inspectionReportRef?.current){
            inspectionReportRef.current.click();
        }
    }
        
    const _handleInspectionReportFileChange = (e) => {
        setInspectionReport(e.target.files[0]);
        
        inspectionReportRef.current.value = '';
    }
        
    const _handleWaiverFileClick = () => {
        if(waiverRef?.current){
            waiverRef.current.click();
        }
    }
        
    const _handleWaiverFileChange = (e) => {
        setWaiverUpload(e.target.files[0]);
        
        waiverRef.current.value = '';
    }

    const initalValues = {
        inspectiontype: '',
        inspectiondate: '',
        inspectionstatus: '',
        comments: '',
        waiverstatus: ''
    }
        
    const {handleSubmit,register,reset} = useForm({defaultValues: initalValues});

    const _handleSubmit = (values) => {
        const insertVal = {
            id: crypto.randomUUID(),
            inspectiontype: values.inspectiontype,
            inspectiondate: values.inspectiondate,
            inspectionstatus: values.inspectionstatus,
            inspectionreport: inspectionReport,
            comments: values.comments,
            clientsignedwaiver: waiverUpload,
            waiverstatus: values.waiverstatus,
            lastmodifieddate: null,
            lastmodifiedby: null
        }

        prepend(insertVal);
        setInspectionReport(null);
        setWaiverUpload(null);
        reset(initalValues);
    }

    return(
        <tr>
            <td className="align-middle">
                {
                    InspectionTypes.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register('inspectiontype')} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle">
                <input type="date" {...register('inspectiondate')} style={{width: '100%'}}/>
            </td>
            <td className="align-middle">
                {
                    InspectionStatuses.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register('inspectionstatus')} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle">
                {
                    inspectionReport
                    ?
                        <div className='d-flex align-items-center'>
                            <a href={URL.createObjectURL(inspectionReport)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                 View File
                            </a>
                            <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setInspectionReport(null)}>
                                <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                            </ButtonOverride>
                        </div>
                    :
                        <Button id="bidupload" type="button" variant="success" onClick={_handleInspectionReportFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                }
                <input ref={inspectionReportRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleInspectionReportFileChange}/>
            </td>
            <td className="align-middle">
                <textarea rows={2} placeholder="Comments" {...register('comments')} />
            </td>
            <td className="align-middle">
                {
                    waiverUpload
                    ?
                        <div className='d-flex align-items-center'>
                            <a href={URL.createObjectURL(waiverUpload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                 View File
                            </a>
                            <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setWaiverUpload(null)}>
                                <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                            </ButtonOverride>
                        </div>
                    :
                        <Button id="bidupload" type="button" variant="success" onClick={_handleWaiverFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                }
                <input ref={waiverRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleWaiverFileChange}/>
            </td>
            <td className="align-middle">
                {
                    ActionTypes.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register('waiverstatus')} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle"></td>
            <td className="align-middle"></td>
            <td className="align-middle">
                <div className="d-flex align-items-center">
                    <Button type="button" variant="primary" onClick={handleSubmit(_handleSubmit)}>
                        Insert
                    </Button>
                </div>
            </td>
        </tr>
    )
}

export default InspectionsQuickAdd;
